
import Vue from 'vue'
import Component from 'vue-class-component'

// import { faceCompareImage } from '../scripts/mock'
import loadingLottieAll from '@/components/loadingLottieAll.vue'
import openView from '@/common/open-view'
import { Md5 } from 'ts-md5'
import { Toast } from 'vant'
import {
  getQueryParams,
  getRandomUniqueElement,
  getSStorageInfo,
  isSource,
  setSStorageInfo,
} from '@/common'
import {
  commitWitnessWay,
  liveDetectionAll,
  facecComparison,
  submitSingleVideo,
  updateprogress,
  reject,
  getAccounTime,
} from '@/api'
import dayjs from 'dayjs'

@Component({
  components: {
    loadingLottieAll,
  },
})
export default class IndexView extends Vue {
  type = 1 // type 0双向 1单项 2活体
  userInfo: any = {}

  startRecord = false
  url = ''
  hasFlow = false //是否使用后管
  qualityRule = []
  custName = ''
  isBank: boolean = false
  videoRecordStartTime: any = ''
  liveRecordStartTime: any = ''
  filePath = '' // 录像文件路径
  source: any = {}
  serviceTime: string = ''
  content: any = {}
  async created() {
    let url = window.anyChat_H5_living_action
    this.commitWitnessWay()
    this.next(url)
  }
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  }
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage, false)
    const url: any = new URL(window.location.href)
    const sParams: any = new URLSearchParams(url.search)
    this.source = sParams.get('source') || ''
  }
  // 提交认证方式
  commitWitnessWay() {
    commitWitnessWay({
      witnessWay: this.type,
      accountId: this.userInfo.accountId,
    }).then((res: any) => {
      if (res.code != 0) {
        this.$emit('actionCallBack', { err: '认证方式提交失败' }, this.type)
        this.clearIframe('recordIframe', false)
        return
      }
    })
  }
  next(url: any) {
    // url = window.anyChat_H5_living_action
    // url = 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idrPrepare'
    // url = 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr_living'
    // url = 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr' // 单向认证
    // url = 'https://livetest.jzsec.com:8941/AnyChat/h5/index.html#/idr_living_action' // 活体验证
    console.log('anyChat_H5_url', url)

    this.url = url
    this.startRecord = true
    this.liveRecordStartTime = Date.now()
  }

  // 人脸识别取消
  livingActionBack() {
    this.clearIframe('recordIframe', false)
    return
  }
  // 活体验证完成
  async livingActionSuccess(data: any) {
    let livingData = JSON.parse(data)
    if (livingData.content.result != 1) {
      this.$emit('actionCallBack', { err: '人脸识别失败' }, this.type)
      this.clearIframe('recordIframe', false)
      return
    } else {
      let picture = livingData?.content?.picture
      if (picture) {
        picture = picture.replace('data:image/png;base64,', '')
        sessionStorage.setItem('facePic', JSON.stringify(picture))
      }

      this.$emit('actionCallBack', { msg: 'loading' }, 100)
      if (this.type == 2) {
        this.submitLiveDetectionAll(data)
      } else if (this.type == 1) {
        this.submitLiveSingle(data)
      }
    }
  }

  // 理财户活体提交 人脸比对 抓拍上传 公安认证
  submitLiveDetectionAll(data: any) {
    let livingData = JSON.parse(data)
    let picture = livingData?.content?.picture
    const videoThumbnail = picture.replace('data:image/png;base64,', '')
    const time = new Date().getTime()
    const signStr =
      'jzcappAD_' +
      time +
      'user_id:' +
      this.userInfo.accountId +
      ';img_data_md5:' +
      Md5.hashStr(videoThumbnail).toString()

    // 人像识别、正面照上传、公安认证、人脸识别
    liveDetectionAll({
      accountId: this.userInfo.accountId,
      faceImgData: videoThumbnail,
      idNo: this.userInfo.idno,
      custName: this.userInfo.custname,
      startTime: time,
      auth: Md5.hashStr(signStr).toString(),
    })
      .then(async (res: any) => {
        const { code, data, msg } = res
        console.log('人像识别、正面照上传、公安认证、人脸识别==>res', res)
        // 人脸通过
        if (code == 0) {
          // 理财户提交
          openView('return-visitor', { type: this.type })
          this.clearIframe('recordIframe', false)
        } else {
          // 人脸不通过
          sessionStorage.setItem('video-error-msg', msg)
          this.$emit('actionCallBack', { err: '人脸认证失败' }, this.type)
          this.clearIframe('recordIframe', false)
        }
      })
      .catch(err => {
        this.$emit('actionCallBack', { err: err || '人脸认证失败' }, this.type)
        this.clearIframe('recordIframe', false)
      })
  }
  // 单向提交 人脸比对
  submitLiveSingle(data: any) {
    let livingData = JSON.parse(data)
    let picture = livingData?.content?.picture
    const videoThumbnail = picture.replace('data:image/png;base64,', '')
    const time = new Date().getTime()
    const signStr =
      'jzcappAD_' +
      time +
      'user_id:' +
      this.userInfo.accountId +
      ';img_data_md5:' +
      Md5.hashStr(videoThumbnail).toString()

    // 人像识别
    facecComparison({
      accountId: this.userInfo.accountId,
      imgData: videoThumbnail,
      time: time,
      auth: Md5.hashStr(signStr).toString(),
      isFaceComp: 'N',
    })
      .then(async (res: any) => {
        const { code, data } = res
        console.log('人像识别==>res', res)
        // 人脸通过
        if (code == 0 && res.data.result == 1) {
          getAccounTime({}).then((sres: any) => {
            this.serviceTime = dayjs(sres.data.tradeTime).format('YYYY-MM-DD hh:mm:ss')
            this.saveJDinfo({})
          })
          console.log('---------', this.type)

          // 股票户继续走单向视频
          // if (this.type == 1) {
          this.$emit('actionCallBack', { msg: 'loading' }, 300)
          this.invokeVideoRecord()
          return
          // }
        } else {
          // 人脸不通过
          sessionStorage.setItem('video-error-msg', res.msg)
          this.$emit('actionCallBack', { err: '人脸认证失败' }, this.type)
          this.clearIframe('recordIframe', false)
        }
      })
      .catch(err => {
        this.$emit('actionCallBack', { err: '人脸认证失败' }, this.type)
        this.clearIframe('recordIframe', false)
      })
  }

  // 单向视频认证
  invokeVideoRecord() {
    this.$emit('actionCallBack', { msg: 'loading' }, -1)
    this.videoRecordStartTime = Date.now()
    this.next(window.anyChat_H5_idr)
  }
  // 单向视频录制完成
  idrFinish(filePath: any) {
    this.$emit('actionCallBack', { msg: 'loading' }, 100)
    this.submitSingleVideo(filePath)
  }
  // 单项视频提交
  submitSingleVideo(filePath: any) {
    submitSingleVideo({
      accountId: this.userInfo.accountId, //用户ID
      videoUrl: filePath, //视频存放的路径
      startTime: this.videoRecordStartTime, // 开始视频见证时间
      opSource: '', //客户端来源(未使用)
      backStepFlag: this.isBank ? '1' : '0',
    }).then((res: any) => {
      const { code } = res
      if (code !== 0) {
        this.$emit('actionCallBack', { err: res.msg }, this.type)
        this.clearIframe('recordIframe', false)
        return
      }
      // 成功
      if (code == 0) {
        if (this.userInfo.needVideo || this.userInfo.needPhotoNohat) {
          const rejectParam = {
            accountId: this.userInfo.accountId,
            fieldname: this.userInfo.needPhotoNohat ? 'video_two' : 'video_one',
          }
          reject(rejectParam).then((rejectRes: any) => {
            if (rejectRes.code != '0') {
              Toast(rejectRes.msg || '进度修改失败')
            }
            if (rejectRes.code == '0') {
              this.userInfo.needVideo = ''
              this.videoUpdateProgress()
            }
          })
        } else {
          this.videoUpdateProgress()
        }
      }
    })
  }
  toNext() {
    openView('return-visitor', { type: this.type })
  }

  saveJDinfo(params: any) {
    if (isSource('0002')) {
      const data: any = JSON.parse(getSStorageInfo('jDInfo') || '{}')
      let jDInfo = {
        ...data,
        ...{
          realNameTime: this.serviceTime,
          realNameAuthStatus: '1',
        },
      }
      setSStorageInfo('jDInfo', JSON.stringify(jDInfo))
    }
  }
  // 更新进度
  videoUpdateProgress() {
    const videoParam = {
      accountId: this.userInfo.accountId,
      progress: '330',
      mobilephone: this.userInfo.mobileno || this.userInfo.mobilephone,
      channelFlag: '',
      channelId: '',
    }
    updateprogress(videoParam)
      .then((videoRes: any) => {
        if (videoRes && videoRes.code == '0') {
          this.toNext()
        } else {
          return this.$emit('actionCallBack', { err: '更新进度失败' }, this.type)
        }
      })
      .catch(() => {
        return this.$emit('actionCallBack', { err: '更新进度失败' }, this.type)
      })
  }

  // 销毁iframe
  clearIframe(id: any, reload: boolean = true) {
    let el: any = document.getElementById(id)
    console.log(el)
    el.remove()
    this.logout()
    this.$destroy()
  }
  logout() {
    console.log('调用退出')
    this.postMsg({
      cmd: 'livingActionLogout',
      content: this.content,
    })
  }
  receiveMessage(e: any) {
    var data = e.data
    if (data && data.cmd) {
      switch (data.cmd) {
        case 'cancelRecord':
        case 'cancelIframe':
          this.clearIframe('recordIframe')
          break
        case 'offline':
          console.log('断网')
          break

        case 'idrFinish':
          console.log('finish: ', data)
          this.filePath = data.content.finishResult.filePath
          console.log('单项认证结束', this.filePath)
          this.idrFinish(this.filePath)

          break

        // 双录环节
        case 'idrReady':
          if (!this.hasFlow) {
            this.idrReady()
          } else {
            this.idrReadyFlow()
          }

          break

        case 'idrFilePath':
          console.log('录像文件路径' + JSON.stringify(data))
          break

        case 'error':
          console.log('异常处理' + JSON.stringify(data))
          setTimeout(() => {
            this.clearIframe('recordIframe')
          }, 2000)
          // this.url = this.url.replace(/#.+/, '#/idr_living');
          break

        case 'livingActionReady':
          this.idrReady()
          break

        case 'livingActionFinish':
          console.log('动作人脸识别环节完成' + JSON.stringify(data))
          this.livingActionSuccess(JSON.stringify(data))
          break

        case 'hidden':
          this.clearIframe('recordIframe')
          console.log('切后台或关掉屏幕' + JSON.stringify(data))
          break

        case 'livingNumReady':
          this.idrReady()
          break

        case 'businessDataLack':
          console.log('业务参数缺失' + JSON.stringify(data))
          break

        case 'livingActionBack':
          //人脸识别点击取消
          // this.clearIframe('recordIframe')
          this.livingActionBack()
          break
      }
    }
  }
  //有后管的传参方式
  idrReadyFlow() {
    let content = {
      hasFlow: this.hasFlow,
      integratorCode: 'Channel01', //质检条目
      businessCode: '1',
      productCode: 'h5test01',
      params: {
        custName: this.custName,
      },
      showVconsole: true,
      thirdTradeNo: new Date().getTime() + '',
      loginIp: window.anyChat_H5_deploy.loginIp,
      loginPort: window.anyChat_H5_deploy.loginPort,
      loginAppId: window.anyChat_H5_deploy.loginAppId,
      videoPathPrefix: window.anyChat_H5_deploy.videoPathPrefix,
      businessLog: this.userInfo.mobileno || this.userInfo.mobilephone,
      remoteStream: window.anyChat_H5_deploy.remoteStream,
      aiConfig: window.anyChat_H5_deploy.aiConfig,
      // 人脸捕获开关
      faceCapture: true,
      // // 人脸比对开关
      faceCompare: true,
      // // 人脸在框开关
      faceDetect: true,
      faceCompareImage: this.getSession('facePic'),
      // faceCompareImage: '',
      qualityRuleJsonStr: [],
    }
    this.postMsg({
      cmd: 'idrBusData',
      content,
    })
  }
  getSession(key: any) {
    return JSON.parse(window.sessionStorage.getItem(key) || '{}')
  }
  idrReady() {
    const spArr: any = [
      {
        actionTypeNum: 6,
        tips: '摇摇头',
        type: '摇头',
      },
      {
        actionTypeNum: 5,
        tips: '点点头',
        type: '点头',
      },
      {
        actionTypeNum: 1, //动作类型，每个数字代表不同动作类型
        tips: '眨眨眼', //动作提示语，话术
        type: '眨眼', //动作类型描述
      },
      {
        actionTypeNum: 2,
        tips: '张张嘴',
        type: '张嘴',
      },
    ]
    const content = (this.content = {
      showVconsole: false,
      thirdTradeNo: new Date().getTime() + '',
      loginIp: window.anyChat_H5_deploy.loginIp,
      loginPort: window.anyChat_H5_deploy.loginPort,
      loginAppId: window.anyChat_H5_deploy.loginAppId,
      videoPathPrefix: window.anyChat_H5_deploy.videoPathPrefix,
      remoteStream: window.anyChat_H5_deploy.remoteStream,
      aiConfig: window.anyChat_H5_deploy.aiConfig,
      // 人脸捕获开关
      faceCapture: true,
      // // 人脸比对开关
      faceCompare: true,
      // // 人脸在框开关
      faceDetect: true,
      faceCompareImage: this.getSession('facePic'),
      // faceCompareImage: '',
      actionType: [getRandomUniqueElement(spArr)],
      qualityRuleJsonStr:
        this.qualityRule.length > 0
          ? this.qualityRule
          : [
              {
                checkQuestion: `请将面部置于框中，回答几个问题。请问您是${this.userInfo.custname}${
                  this.userInfo.idno.substring(16, 17) % 2 !== 0 ? '先生' : '女士'
                }吗？请回答“是”或“否”。`,
                expectAnswer: '是,对,四,似,式,知晓,4',
                errorAnswerStr: '不,否',
                type: 1,
              },
              {
                checkQuestion:
                  '请问您是否是自愿开通证券账户并自愿承担证券市场可能出现的各种风险？请回答“是”或“否”。',
                expectAnswer: '是,对,四,似,式,知晓,4',
                errorAnswerStr: '不,否',
                type: 1,
              },
              // {
              //     answerErrorInterrupt:false,//匹配到黑名单是否阻止
              //     checkQuestion:"请您确认无误后，大声朗读以下内容：",
              //     errorAnswerStr:"不,不知晓",//黑名单
              //     expectAnswer:"我已知晓证券市场风险，并已阅读且充分理解开户协议条款。",
              //     rightAnswerStr:["我","开户,开夫"],//白名单
              //     type:2
              // },
              {
                checkQuestion: '相关的开户协议及风险揭示内容您是否阅读并理解？请回答“是”或“否”。',
                expectAnswer: '是,对,四,似,式,知晓,4',
                errorAnswerStr: '不,否',
                type: 1,
              },
            ],
      // qualityRuleJsonStr:
    })
    this.postMsg({
      cmd: 'livingActionData',
      content,
    })

    this.postMsg({
      cmd: 'idrBusData',
      content,
    })

    this.postMsg({
      cmd: 'livingNumData',
      content,
    })
  }
  postMsg(data: any) {
    // console.log("发送信息：" + JSON.stringify(data));
    const current: any = document.getElementById('recordIframe')
    current?.contentWindow.postMessage(data, '*')
  }
}
